    export class UserAbilitiesModel  {
      view: string = "";
      abilities: {} = {}
      checkAbilityEvent = new CustomEvent('showLoadingSpinner', {
            detail: {
            message: 'Loading...',
            timestamp: new Date().toLocaleString()
        },
        bubbles: true, // Set bubbles to true
        });
  
  setAbilities=(data, selected = null)      => {
      Object.keys(data).map((item) => {
          this.view = item;
          this.abilities[item] = {};
          Object.keys(data[item]).map((item2) => {
              this.abilities[item][item2] = item2;
              });
          });
  }
  
  
  
  constructor(data = null) {
      if(data) {
          this.setAbilities(data);
      }
  } 
  
}